import { Dialog, DialogPanel } from '@headlessui/react'
import React from 'react'
import MealCalendar from '../MealCalendar'

const CalendarDialog = ({
  isOpen,
  onClose,
  selectedRecipe = null,
  onAddToIngredients,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50 modal">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="transform overflow-hidden rounded-2xl bg-white shadow-sm border border-gray-200 max-h-[90vh] lg:max-h-none overflow-y-auto">
          <MealCalendar
            isVisible={true}
            selectedRecipe={selectedRecipe}
            onAddToIngredients={onAddToIngredients}
          />
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default CalendarDialog
